import React, {Component} from 'react';
import { getClassNames } from 'dynamic-class-list';
import { DropTarget } from 'react-dnd';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import { Store } from '../../../src/store';
import { update_drop_target, update_active } from '../../Services/Drop/action';
import {Types} from '../../Services/Types';

import DropzonePreview from '../DropzonePreview/index';
import DropzoneColumnTop from '../DropzoneColumnTop';
import DropzoneColumnLeft from '../DropzoneColumnLeft';
import DropzoneColumnRight from '../DropzoneColumnRight';
import DropzoneColumnBottom from '../DropzoneColumnBottom';

import './style.scss';

export const ItemTypes = {
    CARD: 'card'
};

class Row extends Component {
    constructor(props, context) {
		super(props, context);

        this.state = {
            activeRow: false
        }
    }

    render = () => {
        const {isOver, getItem, value, index, dropTarget, right, bottom, classes} = this.props;
        if(isOver)
        {
            var dropZonesStyle = getClassNames({
                'dropzones': function() {
                    return true
                },
                'active': function() {
                    if(value.active)
                    {
                        return true;
                    }else {
                        return false;
                    }
                }.bind(this)
            });

        }
        else {
            var dropZonesStyle = getClassNames({
                'dropzones': function() {
                    return true
                },
                'acitve-item': function() {
                    if(value.active)
                    {
                        if(value.item)
                        {
                            return true;
                        }
                    }
                    return false;
                }.bind(this),
                'active': function() {
                    if(value.active)
                    {
                        if(value.item)
                        {
                            return false;
                        }else {
                            return true;
                        }
                        
                    }else {
                        return false;
                    }
                }.bind(this)
            });
        }
        let count = 0;
        const childs = value.items.map(function(val, childIndex){
            count += 1;
            switch(val.types){
                case 'top':
                    
                    return <DropzoneColumnTop value={value} dropElements={value} key={childIndex} mainTarget={val} childIndex={childIndex} mainIndex={index} />
                    
                case 'right':

                    if(right)
                    {
                        return <DropzoneColumnRight dropElements={value} key={childIndex} mainTarget={val} childIndex={childIndex} mainIndex={index} />                         
                    }
                       
                case 'left':
                    
                        return <DropzoneColumnLeft dropElements={value} key={childIndex} mainTarget={val} childIndex={childIndex} mainIndex={index} />
                        
                    
                case 'bottom':
                    if(bottom)
                    {
                        return <DropzoneColumnBottom dropElements={value} key={childIndex} mainTarget={val} childIndex={childIndex} mainIndex={index} />
                    }
                        // r
                    
                       
            }
            count++;
        })

        let style = {};
        if(classes)
        {
            switch(classes){
                case 'bottom':
                    style = {
                        borderBottom: '1px dotted rgb(182, 182, 182)'
                    }
                break;
                case 'right':
                    style = {
                        borderRight: '1px dotted rgb(182, 182, 182)'
                    }
                break;
                default:
                break;
            }
            
        }

        return  (
            <div className="drop" style={style}>
                <div className={dropZonesStyle}>
                    <div className="testdropcontainer">
                    {childs}
                    </div>
                    { /* appendTarget */}
                </div>
            </div>
        )
    }
}
export default Row; 
//xport default connect(mapStateToProps, mapDispatchToProps)(Row);


// WEBPACK FOOTER //
// ./src/Components/DropzoneRow/index.js